<template>
  <div id="app" :class="{ 'homepage-v23': isHome }">
    <!--main content-->
<!--    {{showPlayer ? 't' : 'f'}}-->
<!--    {{isPlaying ? 't' : 'f'}}-->
    <Header />
    <HomeBanner v-if="isHome" />
    <router-view />
    <StickyPlayer :showPlayer="showPlayer || isPlaying" v-if="isHome"/>
    <AnalyticsConsent />
    <!--end main content-->
  </div>
</template>

<script>
import HomeBanner from "./components/partials/HomeBanner.vue";
import Header from "./components/partials/Header.vue";
import AnalyticsConsent from "./components/partials/AnalyticsConsent.vue";

//import StickyPlayer from "./components/partials/StickyPlayer.vue";
import StickyPlayer from "./components/partials/StickyPlayer";
import {mapGetters} from "vuex";

export default {
  name: "App",
  components: {
    HomeBanner,
    Header,
    StickyPlayer,
    AnalyticsConsent,
  },
  computed: {
    isHome() {
      return this.$route.name === 'Home' || this.$route.name === 'HomeGenre'
          || this.$route.name === 'HomeMood' || this.$route.name === 'HomeSearch' || this.$route.name === 'HomeTempo'
          || this.$route.name === 'HomeMusic' || this.$route.name === 'HomeMusicPage'
          || this.$route.name === 'HomeMusicLegacy' || this.$route.name == 'HomeSoundEffects'
    },
    ...mapGetters({
      showPlayer : 'player/getShowStickyPlayer',
      loading : 'player/getIsLoading',
      isPlaying: 'player/getIsPlaying',
    }),
  }
};
</script>


<style>
.ad-placeholder {
  display: block;
  min-height: 112px;
  margin: 24px 0;
  padding: 22px;
  border: 1px solid #dedede;
  background: #fafafa;
  color: #5f6368;
  text-align: center;
  font-weight: 600;
  border-radius: 10px;
  line-height: 1.4;
  box-shadow: inset 0 0 0 1px rgba(255,255,255,.75);
}
.ad-placeholder::before {
  content: "Advertisement";
  display: inline-block;
  padding: 2px 8px;
  border: 1px solid #d6d6d6;
  border-radius: 999px;
  background: #fff;
  color: #777;
  font-size: 11px;
  letter-spacing: .08em;
  text-transform: uppercase;
}
.ad-placeholder[data-ad-slot]::after {
  content: "Reserved space - no ad network is active";
  display: block;
  margin-top: 8px;
  font-size: 0.82rem;
  font-weight: 400;
}
.ad-placeholder.ad-placeholder-rail {
  position: sticky;
  top: 96px;
  min-height: 360px;
}
.ad-placeholder.ad-placeholder-mobile {
  min-height: 72px;
  margin: 16px;
  padding: 16px;
}
.ad-placeholder.ad-placeholder-prefooter {
  min-height: 90px;
}
@media (max-width: 991px) {
  .ad-placeholder {
    min-height: 72px;
    margin: 16px 0;
    padding: 16px;
  }
}
</style>
